module.exports = __webpack_public_path__ + "static/media/XXXIIe.6c05129b.png";